import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { FragmentMessages } from "../../common/fragment-messages";

export default class KickOffPenaltyDeclined extends Fragment {
    constructor(team, fieldPosition) {
        super();

        this.team = team;
        this.fieldPosition = fieldPosition;

        this.requiredData = [
            {
                name: "team",
                type: FragmentDataType.Team,
                displayName: "Team",
                title: "Team",
                subtitle: "Select the team possession"
            },
            {
                name: "fieldPosition",
                type: FragmentDataType.FieldPosition,
                displayName: "Field Position",
                title: "Field Position",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION
            }
        ];
    }

    summarize(summaryContext, stringifier) {
        const message = `Declined, possession set for ${this.team?.teamName} and field position set `;

        return new FragmentSummary(message, "");
    }

    updateSummaryContext(summaryContext) {
        summaryContext.homeTeamHasPossession =
            this.team?.id === summaryContext?.homeTeamId;
        summaryContext.fieldPosition = this.fieldPosition;
    }

    getFragmentTeamId() {
        return this.team?.id;
    }

    toJSON() {
        return {
            ...super.toJSON()
        };
    }
}
